module.exports = __webpack_public_path__ + "static/media/taffiethule36.f9435616.jpg";